/**
 * Automatic Sync Service
 * Starts and manages the automatic Shiprocket synchronization
 */

import { startAutomaticSync, stopAutomaticSync } from '../utils/automaticShiprocketSync';

class AutomaticSyncService {
  constructor() {
    this.isRunning = false;
    this.startTime = null;
  }

  /**
   * Start the automatic synchronization service
   */
  start() {
    if (this.isRunning) {return;
    }

    try {startAutomaticSync();
      this.isRunning = true;
      this.startTime = new Date();} catch (error) {
      console.error('❌ Failed to start automatic sync service:', error);
    }
  }

  /**
   * Stop the automatic synchronization service
   */
  stop() {
    if (!this.isRunning) {return;
    }

    try {stopAutomaticSync();
      this.isRunning = false;
      this.startTime = null;} catch (error) {
      console.error('❌ Failed to stop automatic sync service:', error);
    }
  }

  /**
   * Get the status of the automatic sync service
   */
  getStatus() {
    return {
      isRunning: this.isRunning,
      startTime: this.startTime,
      uptime: this.startTime ? Date.now() - this.startTime.getTime() : 0
    };
  }

  /**
   * Restart the automatic synchronization service
   */
  restart() {this.stop();
    setTimeout(() => {
      this.start();
    }, 1000);
  }
}

// Create a singleton instance
const automaticSyncService = new AutomaticSyncService();

export default automaticSyncService;
